import React from "react";

const Layout = ({ children }) => {
  return <div className="tablet:mt-5 tablet:mx-10">{children}</div>;
};

export default Layout;
